export const SERVER_ALERT_RULE_METRICS = [
    'cpu_busy',
    'cpu_iowait',
    'cpu_steal',
    'la1_per_core',
    'la5_per_core',
    'la15_per_core',
    'mem_available_pct',
    'swap_used_pct',
    'swap_io_rate',
    'fs_used_pct',
    'fs_inodes_pct',
] as const;

export type ServerAlertRuleMetric = typeof SERVER_ALERT_RULE_METRICS[number];

export type ServerAlertRuleOperator = '>' | '<' | '>=' | '<=';
export type ServerAlertRuleSeverity = 'warning' | 'critical';

export default interface IServerAlertRule {
    uuid: string,
    server: string | null,
    metric: ServerAlertRuleMetric,
    scope: string | null,
    operator: ServerAlertRuleOperator,
    threshold: number,
    for_seconds: number,
    recover_seconds: number | null,
    severity: ServerAlertRuleSeverity,
    enabled: boolean,
    created_at: string,
}
